<ng-container *transloco="let t">
  <section
    class="featured-purchase-info-card"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <!-- Price Header-->

    <section class="price-header">
      @if (product) {
        <span class="title-wrapper flex align-base">
          <h4 class="">{{ product?.title || product?.model || '...' }}</h4>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <popsy-icon-check-badge class="icon primary"></popsy-icon-check-badge>
        </span>
      }
      @if (!product) {
        <span class="flex flex-col align-base full-width">
          <popsy-skeleton class="skeleton full-width border-box"></popsy-skeleton>
          <span class="fixed-space-4" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton full-width border-box"></popsy-skeleton>
        </span>
      }
      <span class="fixed-space-8" aria-hidden="true"></span>
      <span class="flex align-base flex-mobile">
        @if (product) {
          <h4 class="text-secondary">{{ price$ | async | amount }}</h4>
          <span
            class="small nowrap"
            [innerHTML]="
              t('price_banner_secondary_or', {
                var1: price$ | async | installmentAmount
              })
            "></span>
        }
      </span>
    </section>

    <!-- Sub-Header -->

    <section class="flex sub-title">
      <span class="small"> {{ t(getTransLabel(product?.color || '')) || '' }} </span>
      <span class="fixed-space-8" aria-hidden="true"></span>
      @if (product?.storage) {
        <span class="vertical-line dark"></span>
        <span class="fixed-space-8" aria-hidden="true"></span>
        <span class="small">{{ product?.storage || '' }}GB</span>
      }
      @if (product?.category === 'SMARTPHONE') {
        <span class="fixed-space-8" aria-hidden="true"></span>
        <span class="vertical-line dark"></span>
        <span class="fixed-space-8" aria-hidden="true"></span>
        <span class="small">{{ t('label_product_unlocked') }}</span>
      }
    </section>

    <span class="fixed-space-4" aria-hidden="true"></span>

    <!-- PRODUCT OPTIONS -->
    @if (isBrowser) {
      <app-featured-details-card
        class="column"
        [productId]="product?.id"
        [currency]="currency"
        [model]="product?.model"
        [category]="product?.category"
        [insuranceIds]="product?.insuranceIds"></app-featured-details-card>
    }
    <!-- PAYMENT BUTTONS -->
    @if ((biggerThan$ | async)?.sm) {
      <span class="fixed-space-16" aria-hidden="true"></span>
      <app-featured-buy-buttons
        [product]="product"
        [showBuyNow]="true"></app-featured-buy-buttons>
    }

    <span class="fixed-space-16" aria-hidden="true"></span>

    <app-product-installment-options
      [product]="product"
      [price]="price$ | async"
      [installmentsCount]="instalmentsCount"
      [tamaraInstallmentPrice]="instalmentPrice()" />

    <span class="fixed-space-16" aria-hidden="true"></span>

    <!--  <popsy-quara-promo
      [amount]="(price$ | async)?.amount"
      [currency]="product?.price?.currency"
      [country]="product?.country"
      source="product"></popsy-quara-promo>

    <span class="fixed-space-16" aria-hidden="true"></span>

    <popsy-baseeta-promo
      [amount]="(price$ | async)?.amount"
      [currency]="product?.price?.currency"
      [country]="product?.country"
      source="product"></popsy-baseeta-promo>

    <span class="fixed-space-16" aria-hidden="true"></span> -->

    <!-- //Tabby card -->
    <!--  <div class="popsy-card card flex-row">
      <div class="flex align-base flex-wrap">
        <span class="small">{{ t('label_pay_as_low') }}</span>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span class="small bold"> {{ instalmentPrice() | amount }}</span>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span class="small">{{
          t('label_n_installments', { var1: instalmentsCount })
        }}</span>
      </div>
      <div class="flex align-center justify-between">
        <span class="dynamic-space" aria-hidden="true"></span>

        <div class="hidden-container">
          <popsy-icon-tabby class="icon promo"> </popsy-icon-tabby>
          <popsy-tabby-promo
            class="hidden-element"
            [amount]="(price$ | async)?.amount"
            [currency]="product?.price?.currency"
            source="product" />
        </div>
      </div>
    </div>

    <span class="fixed-space-16" aria-hidden="true"></span> -->

    <!-- Tamara card -->
    <!-- <div class="popsy-card card">
      <div class="flex align-base flex-wrap">
        <span>{{ t('label_tamara_instalments', { var1: instalmentsCount }) }}</span>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <strong> {{ instalmentPrice() | amount }}/mo</strong>
        <span class="fixed-space-4" aria-hidden="true"></span>-
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span>{{ t('label_tamara_instalments_2') }}</span>
      </div>
      <div class="flex align-center justify-between">
        <span class="small">{{ t('sub_label_tamara_instalments') }}</span>

        <span class="dynamic-space" aria-hidden="true"></span>
        <div class="hidden-container">
          <popsy-tamara-summary
            class="hidden-element"
            [productId]="product?.id"
            [amount]="(price$ | async)?.amount"
            [currency]="product?.price?.currency"
            [country]="product?.country"
            source="product" />
          <popsy-icon-tamara class="icon promo" />
        </div>
      </div>
    </div>

    <span class="fixed-space-16" aria-hidden="true"></span>
 -->
    <popsy-shipping-estimate-card
      [country]="product?.country"></popsy-shipping-estimate-card>
    @if (product?.country === 'US') {
      <span class="fixed-space-16" aria-hidden="true"></span>
      <popsy-premium-shipping-estimate-card></popsy-premium-shipping-estimate-card>
    }
  </section>
</ng-container>
